export default __webpack_public_path__ + "static/media/Kopas of the Dunes.f4728364.jpg";